import React from 'react'
import { cn } from '@appfluence/classnames'
import { useDispatch, useSelector } from 'react-redux'
import { authSelectors, teamsSelectors } from '../../common/src/selectors'
import { Ribbon } from './Ribbon'
import { EVENT_EXTRA } from '../../common/src/eventTracking/amplitudeEvents'
import { useTranslation } from 'react-i18next'
import { openPurchaseExperienceAction } from '../../utils/teams'

const UpgradeRibbon_ = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const licensed = useSelector(authSelectors.hasLicense)
  const isTeamsMobile = useSelector(teamsSelectors.isMobileHost)
  const shouldDisplay = licensed === false && !isTeamsMobile
  const containerClassName = cn({ pm_hidden: !shouldDisplay })
  const onClick = () => {
    dispatch(openPurchaseExperienceAction(EVENT_EXTRA.TRIAL_UPGRADE_PRESSED.MODE.RIBBON))
  }

  return (
    <div className={containerClassName}>
      <Ribbon onClick={onClick}>{t('general.upgrade')}</Ribbon>
    </div>
  )
}

export const UpgradeRibbon = React.memo(UpgradeRibbon_)
